import React, { memo, useState, useEffect, useCallback } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import MapPolygon from '../MapObjects/MapPolygon';
import { Box, Divider, Typography, MenuList } from '@mui/material';
import { useLangFile } from '../../context/LanguageContext';
import MapFieldHole from '../MapObjects/MapFieldHole';
import { Coordinate, CoordinateObject, PolygonCoordinates, Ring } from '../../../types/geo';
import FieldTextCanvas from '../ManageCrops/FieldTextCanvas';
import { getFieldName } from '../../helpers/StateInterpreters';

const mapStoreToProps = (store: any) => ({
  selectedField: store.field.selectedField,
});

type PropsFromRedux = ConnectedProps<typeof connector>;

interface EditFieldViewProps extends PropsFromRedux {
  menuItems: React.ReactNode[];
}

const EditFieldView: React.FC<EditFieldViewProps> = ({ selectedField, menuItems }) => {
  const LangFile = useLangFile();

  const [coordinates, setCoordinates] = useState(
    selectedField.polygon.coordinates.map((ring: Ring): CoordinateObject[] => {
      return ring.map((coord: Coordinate): CoordinateObject => {
        return {
          lng: coord[0],
          lat: coord[1],
        };
      });
    })
  );

  const [visibleFieldHoles, setVisibleFieldHoles] = useState<PolygonCoordinates>(
    selectedField.polygon.coordinates.slice(1)
  );

  const menuContainerBoxStyle = {
    width: '300px',
    maxHeight: '50vh',
    backgroundColor: 'white',
    position: 'absolute',
    overflow: 'auto',
    borderRadius: '4px',
    boxShadow: '4px 4px 4px rgba(0,0,0,0.4)',
  };

  const renderFieldText = useCallback(
    (field, zoom) => {
      const lines = [];
      if (zoom >= 15) {
        lines.push({
          text: getFieldName(field, LangFile),
          fontWeight: '400',
          fontSize: 14,
          textAlign: 'center',
          color: 'white',
        });
      }
      return lines;
    },
    [selectedField]
  );

  useEffect(() => {
    setCoordinates(
      selectedField.polygon.coordinates.map((ring) => {
        return ring.map((coord: [number, number]) => {
          return {
            lng: coord[0],
            lat: coord[1],
          };
        });
      })
    );
    setVisibleFieldHoles(selectedField.polygon.coordinates.slice(1));
  }, [selectedField.polygon.coordinates]);

  return (
    <>
      <MapPolygon
        fillOpacity={0.0}
        fillColor={'white'}
        strokeColor={'rgb(224,210,61)'}
        strokeWeight={2}
        disabled={true}
        coordinates={coordinates}
        selected={false}
        zIndex={0}
      />
      {visibleFieldHoles &&
        visibleFieldHoles.map((boundary, index) => (
          <MapFieldHole fieldHole={boundary} key={index} fieldHoleDisabled={true} />
        ))}
      <FieldTextCanvas fields={[selectedField]} renderField={renderFieldText} />
      <Box sx={menuContainerBoxStyle}>
        <Box
          sx={{
            mx: 1.5,
            mt: 1.5,
            mb: 1,
            display: 'flex',
          }}
        >
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Box
              sx={{
                mx: 1.5,
              }}
            >
              <Typography>{LangFile.EditFieldMenu.title}</Typography>
            </Box>
          </Box>
        </Box>
        <Divider />
        <MenuList>{menuItems}</MenuList>
      </Box>
    </>
  );
};

const connector = connect(mapStoreToProps);
export default memo(connector(EditFieldView));
